import { render, staticRenderFns } from "./ProposalRejectionInfo.vue?vue&type=template&id=05e7b505"
import script from "./ProposalRejectionInfo.vue?vue&type=script&lang=js"
export * from "./ProposalRejectionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports